import { useQuery } from "@tanstack/react-query";
import { CircleAlert, Info, LoaderCircle, X } from "lucide-react";
import { engagementApi } from "../api/engagement";
import { useCopy } from "../i18n/copy";
import { sanitizeHtml } from "../utils/sanitizeHtml";

export function RemoteNoticeDialog({
  open,
  type,
  onClose,
}: {
  open: boolean;
  type: number;
  onClose: () => void;
}) {
  const { tr } = useCopy();
  const notice = useQuery({
    queryKey: ["notice", type],
    queryFn: () => engagementApi.notice(type),
    enabled: open,
  });

  if (!open) return null;

  return (
    <div
      className="action-sheet-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <section
        className="action-sheet remote-notice-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={`notice-title-${type}`}
        onClick={(event) => event.stopPropagation()}
      >
        <header>
          <span>
            <Info />
          </span>
          <button
            className="icon-action"
            onClick={onClose}
            aria-label={tr("Cerrar")}
          >
            <X />
          </button>
        </header>
        <h2 id={`notice-title-${type}`}>{tr("Reglas")}</h2>
        {notice.isLoading && (
          <div className="loading-row">
            <LoaderCircle className="spin" /> {tr("Cargando…")}
          </div>
        )}
        {notice.isError && (
          <div className="form-feedback error">
            <CircleAlert /> {tr("No pudimos cargar el contenido.")}
          </div>
        )}
        {notice.data?.content && (
          <div
            className="remote-notice-content"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(notice.data.content),
            }}
          />
        )}
      </section>
    </div>
  );
}
